function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
} }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps)
    _defineProperties(Constructor.prototype, protoProps); if (staticProps)
    _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
import React from 'react';
var ErrorHelper = /*#__PURE__*/ _createClass(function ErrorHelper() {
    var _this = this;
    _classCallCheck(this, ErrorHelper);
    _defineProperty(this, "getFileNameFromPath", function (string) {
        var arrayStr = string.split('/');
        return arrayStr[arrayStr.length - 1];
    });
    _defineProperty(this, "showError", function (message, title) {
        return /*#__PURE__*/ React.createElement("div", null, title, /*#__PURE__*/ React.createElement("br", null), message.map(function (item) {
            return /*#__PURE__*/ React.createElement("div", {
                key: item
            }, item);
        }));
    });
    _defineProperty(this, "errorsFactory", function (error) {
        switch (error.response.status) {
            case 422:
                var statusMessage = "".concat(error.response.status, ": ").concat(error.response.data.message);
                var errorsList = Object.keys(error.response.data.errors).map(function (key) {
                    return "".concat(key, ": ").concat(error.response.data.errors[key]);
                });
                return /*#__PURE__*/ React.createElement("div", null, statusMessage, /*#__PURE__*/ React.createElement("br", null), errorsList.map(function (item) {
                    return /*#__PURE__*/ React.createElement("div", {
                        key: item
                    }, item);
                }));
            case 403:
                return /*#__PURE__*/ React.createElement("div", null, "Status: ", error.response.status, /*#__PURE__*/ React.createElement("br", null), error.response.data.error);
            case 429:
                return /*#__PURE__*/ React.createElement("div", null, "Status: ", error.response.status, /*#__PURE__*/ React.createElement("br", null), error.response.data.error);
            case 405:
                return /*#__PURE__*/ React.createElement("div", null, error.response.status, ": ", error.response.data.message, /*#__PURE__*/ React.createElement("br", null), "File: ", _this.getFileNameFromPath(error.response.data.file), /*#__PURE__*/ React.createElement("br", null), "Line: ", error.response.data.line);
            case 500:
                return /*#__PURE__*/ React.createElement("div", null, error.response.status, ": ", error.response.data.message, /*#__PURE__*/ React.createElement("br", null), "File: ", _this.getFileNameFromPath(error.response.data.file), /*#__PURE__*/ React.createElement("br", null), "Line: ", error.response.data.line);
        }
    });
});
export default new ErrorHelper();
